package com.arenaproplay.admin.ui.components.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.px

@Composable
fun VSpace(px: Int = 16) {
    Box(Modifier.fillMaxWidth().height(px.px))
}

@Composable
fun HSpace(px: Int = 16) {
    Box(Modifier.width(px.px))
}
